import { Helmet } from 'react-helmet-async';
import { AdGeneratorBackground } from 'src/components/common/adGenerator/Background';
import { FlexBoxColumn } from 'src/components/common/FlexBoxColumn';
import { FlexBoxRow } from 'src/components/common/FlexBoxRow';
import { Footer } from 'src/components/common/adGenerator/Footer';
import { Container } from 'src/components/common/adGenerator/Container';
import { WebsiteGraderNavBar } from 'src/components/common/websiteGrader/NavBar';
import { SubFooter } from 'src/components/common/adGenerator/SubFooter';
import { WebsiteGraderUserDetailsForm } from 'src/components/common/websiteGrader/formUserDetails/UserDetailsForm';
import {
  IWebsiteGraderContext,
  useWebsiteGraderContext,
  WebsiteGraderStep,
} from 'src/components/providers/websiteGrader';
import { WebsiteGraderBusinessDetailsForm } from 'src/components/common/websiteGrader/formBusinessDetails/BusinessDetailsForm';
import { Typography, useMediaQuery } from '@mui/material';
import { StyledLinearProgress } from 'src/components/common/progress/LinearProgress';
import { TFunction, useTranslation } from 'react-i18next';
import { ErrorFlexBoxColumn } from 'src/components/common/websiteGrader/Error';
import { LyraTheme as theme } from 'src/components/theme/lyra/Theme';
import { BodyLarge } from 'src/App';

const SwitchStep = (context: IWebsiteGraderContext, t: TFunction, isMobile: boolean): JSX.Element => {
  const errorMessage = typeof context.error === 'string' ? context.error : context.error?.message;
  const errorStatus = typeof context.error === 'string' ? null : context.error?.status;

  switch (context.currentStep) {
    case WebsiteGraderStep.COLLECT_USER_DETAILS:
      return <WebsiteGraderUserDetailsForm />;
    case WebsiteGraderStep.COLLECT_BUSINESS_DETAILS:
      return <WebsiteGraderBusinessDetailsForm />;
    case WebsiteGraderStep.LOADING_RESULTS:
      return (
        <FlexBoxColumn sx={{ gap: 2, justifySelf: 'stretch' }}>
          <Typography variant="h3" textAlign={'center'}>
            {t('loading.text_main')}
          </Typography>
          <BodyLarge>{t('loading.text_time')}</BodyLarge>
          <FlexBoxRow sx={{ alignSelf: 'stretch', pt: isMobile ? 1 : 3 }}>
            <StyledLinearProgress throttle={true} />
          </FlexBoxRow>
        </FlexBoxColumn>
      );
    case WebsiteGraderStep.ERROR:
      return (
        <ErrorFlexBoxColumn
          heading={errorStatus === 500 ? 'Sorry, something went wrong' : errorMessage}
          text={
            errorMessage?.includes('Not Found')
              ? 'We were unable to return your results, please try again later.'
              : errorMessage
          }
        />
      );
    default:
      return <></>;
  }
};

const WebsiteGrader = (): JSX.Element => {
  const context = useWebsiteGraderContext();
  const { t } = useTranslation(['websiteGrader']);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Helmet>
        {/*  */}
        <style>
          {`
                body {
                  background-color: white;
                }
              `}
        </style>
        <link rel="icon" href="/favicon-liq.ico" />
        <meta name="LocaliQ | Website Grader" content="LocaliQ | Website Grader" />
        <link rel="apple-touch-icon" href="/apple-touch-icon-liq.png" />
        <link rel="manifest" href="/manifest-liq.json" />
        <title>LocaliQ | Website Grader</title>
      </Helmet>
      <FlexBoxColumn sx={{ alignItems: 'flex-start' }}>
        <AdGeneratorBackground>
          <FlexBoxRow
            sx={{
              paddingX: isMobile ? 2 : 5,
              paddingTop: isMobile ? 2 : 5,
              paddingBottom: 0,
              alignSelf: 'stretch',
            }}
          >
            <WebsiteGraderNavBar />
          </FlexBoxRow>
          <Container $aiTool={false}>{SwitchStep(context, t, isMobile)}</Container>
          <SubFooter />
          <Footer />
        </AdGeneratorBackground>
      </FlexBoxColumn>
    </>
  );
};

export default WebsiteGrader;
